export const USER_LOG_IN = 'USER_LOG_IN'
export const USER_LOG_OUT = 'USER_LOG_OUT'

export const SET_CLIENT_ID = 'SET_CLIENT_ID'
export const FILL_AUTH = 'FILL_AUTH'


// WEBPACK FOOTER //
// ./src/actions/types.js